/**
 * ID generation utilities
 * Abstracted for testing purposes - can be mocked in tests for deterministic IDs
 */

/**
 * Generates a new UUID v4 identifier
 * Uses the browser's crypto.randomUUID() in production
 *
 * @returns A UUID v4 string (e.g., "123e4567-e89b-12d3-a456-426614174000")
 *
 * @example
 * ```typescript
 * const evaluationId = generateId();
 * const evaluation = { id: evaluationId, name: 'My Evaluation', ... };
 * ```
 */
export function generateId(): string {
  return crypto.randomUUID();
}
